import CommandTypes from '../../../Canvas/commands/types';
import groupUpdateProperties from './updateProperties';

const groupCommands = {
    [CommandTypes.UPDATE_PROPERTIES_ON_SELECTED_SHAPES]: groupUpdateProperties
};

export default groupCommands;
